import React, { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { adminMainUrl } from "../../../Config";
import { toast } from "react-toastify";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import EditPurchaseInvoiceModal from "./EditPurchaseInvoiceModal";



const TradeInvoicesPurchaseInvoiceSearch = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [purchaseInvoiceSearch, setPurchaseInvoiceSearch] = useState({
    from_date: "",
    to_date: "",
    supplier_name: "",
    invoice_no: "",
    invoice_type: "",
    invoice_status: "",
    amount_from: "",
    amount_to: "",
  });

  const [dataSourcer, setDataSourcer] = useState([
    // {
    //   key: 1,
    //   invoice_id: "PI-2025-001",
    //   date: "2025-01-10",
    //   supplier: "Air India Cargo",
    //   invoice_no: "AI-INV-001",
    //   type: "Regular",
    //   amount: "₹ 4,50,000",
    //   status: "Posted",
    //   gst: "GST",
    // },
  ]);
  const [ReceiptVoucherCurrentPage, setReceiptVoucherCurrentPage] = useState(1);
  const [ReceiptVoucherTotalPage, setReceiptVoucherTotalPage] = useState(0);

  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;
    let finalValue = value;
    if (type === "number") {
      const num = Number(value);
      if (num <= 0) {
        finalValue = "";
      } else {
        finalValue = num;
      }
    }
    setPurchaseInvoiceSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };


  const handleView = async (record) => {
    try {
      setViewLoading(true);
      setShowModal(true);

      const res = await axios.get(
        `${adminMainUrl}/api/account/get-purchase-invoice?id=${record.key}`,
        {
          headers: {
            "auth-token": token,
            user_id: user_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        console.log(res.data.data)
        setViewData(res.data.data);
      } else {
        toast.error(res.data?.msg || "Failed to fetch invoice");
        setShowModal(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.msg || "Error fetching invoice details"
      );
      setShowModal(false);
    } finally {
      setViewLoading(false);
    }
  };


  const handleEdit = async (record) => {
    try {
      setViewLoading(true);

      const res = await axios.get(
        `${adminMainUrl}/api/account/get-purchase-invoice?id=${record.key}`,
        {
          headers: {
            "auth-token": token,
            user_id,
          },
        }
      );

      if (res.status === 200) {
        // console.log(res.data.data)
        setEditData(res.data.data);
        setShowEditModal(true);
      } else {
        toast.error("Failed to fetch data");
      }
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Error fetching data");
    } finally {
      setViewLoading(false);
    }
  };


  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "invoice_id",
      key: "invoice_id",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <span
          className={`rounded-pill px-3 py-2 ${type === "RCM" ? "badge-soft-purple" : "badge-soft-primary"
            }`}
          style={{ fontSize: "12px" }}
        >
          {type}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const statusClass = {
          Posted: "bg-primary bg-opacity-10 text-primary",
          Draft: "bg-warning bg-opacity-10 text-warning",
          Paid: "bg-success bg-opacity-10 text-success",
        };

        return (
          <span
            className={`badge rounded-pill px-3 py-2 ${statusClass[status]}`}
            style={{ fontSize: "12px" }}
          >
            {status}
          </span>
        );
      },
    },
    // {
    //   title: "GST",
    //   dataIndex: "gst",
    //   key: "gst",
    //   render: () => (
    //     <span className="rounded-pill px-3 py-2 badge-soft-success">GST</span>
    //   ),
    // },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex gap-2">
          <i
            className="far fa-eye cursor-pointer"
            title="View"
            onClick={() => handleView(record)}
          ></i>
          {/* <i className="far fa-edit cursor-pointer" title="Edit"></i>
           */}
          <i
            className="far fa-edit cursor-pointer"
            title="Edit"
            onClick={() => handleEdit(record)}
          ></i>

          <i
            className="far fa-file-pdf cursor-pointer"
            title="Download PDF"
            onClick={() => handleDownloadPDF(record)}
          ></i>

          <i
            className="fas fa-print cursor-pointer"
            title="Print"
            onClick={() => handlePreviewPDF(record)}
          ></i>
        </div>
      ),
    }
  ];
  const handleDownloadPDF = async (record) => {
    console.log(record)
    try {
      if (!record || !record.key) { toast.error("ID is requried."); return; }
      const response = await axios.post(
        `${adminMainUrl}/api/account/standard-purchase-invoice-print`,
        { id: record.key },
        {
          responseType: "blob", // 🔥 important for PDF
        }
      );

      // ✅ Create blob URL
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement("a");
      a.href = url;
      a.download = "Invoice.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);

      // ❗ Handle API error message
      if (err.response && err.response.data) {
        try {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result);
              toast.error(errorData.message || "Failed to download PDF");
            } catch {
              toast.error("Failed to download PDF");
            }
          };

          reader.readAsText(err.response.data);
        } catch {
          toast.error("Failed to download PDF");
        }
      } else {
        toast.error("Something went wrong while downloading PDF");
      }
    }
  };

  const handlePreviewPDF = async (record) => {
    try {
      if (!record || !record.key) {
        toast.error("ID is required.");
        return;
      }

      const response = await axios.post(
        `${adminMainUrl}/api/account/standard-purchase-invoice-print`,
        { id: record.key },
        { responseType: "blob" }
      );

      const contentType = response.headers["content-type"];

      if (contentType !== "application/pdf") {
        // convert blob to text to read error
        const text = await response.data.text();
        try {
          const errJson = JSON.parse(text);
          toast.error(errJson.message || "Invalid response");
        } catch {
          toast.error("Server did not return a PDF");
        }
        return;
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const newWindow = window.open(url, "_blank");

      if (!newWindow) {
        toast.error("Popup blocked");
        return;
      }

      newWindow.onload = () => {
        newWindow.print();
      };

      setTimeout(() => window.URL.revokeObjectURL(url), 5000);

    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while previewing PDF");
    }
  };

  const searchReceiptVoucher = async (
    token,
    user_id,
    {
      page,
      from_date,
      to_date,
      invoice_type,
      supplier_name,
      invoice_no,
      invoice_status,
      amount_from,
      amount_to,
    },
  ) => {
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/standard-purchase-invoice`;

    const queryParams = [];
    if (page) queryParams.push(`page=${page}`);
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (supplier_name) queryParams.push(`supplier_name=${supplier_name}`);
    if (invoice_no) queryParams.push(`invoice_no=${invoice_no}`);
    if (invoice_type) queryParams.push(`invoice_type=${invoice_type}`);
    if (invoice_status) queryParams.push(`invoice_status=${invoice_status}`);

    if (amount_from) queryParams.push(`amount_from=${amount_from}`);
    if (amount_to) queryParams.push(`amount_to=${amount_to}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    try {
      const res = await axios.get(apiUrl, config);
      // console.log("API Response:", res.data);

      // Transform data to match table columns
      const transformedData = res.data.data.map((item) => ({
        key: item.id, // required by AntD Table
        invoice_id: item.invoice_id,
        date: item.invoice_date
          ? new Date(item.invoice_date).toLocaleDateString()
          : "-",
        supplier: item.supplier_name || "—",
        invoice_no: item.invoice_no || "—",
        type: item.invoice_type || "—",
        status: item.invoice_status || "—",
        amount: item.net_payable
          ? `₹ ${Number(item.net_payable).toLocaleString("en-IN")}`
          : "—",
      }));

      setDataSourcer(transformedData);
      setReceiptVoucherCurrentPage(res.data.pagination.currentPage || 1);
      setReceiptVoucherTotalPage(res.data.pagination.totalPages || 0);
    } catch (error) {
      console.error("Error fetching receipt vouchers:", error);
    }
  };

  const {
    from_date,
    to_date,
    invoice_type,
    supplier_name,
    invoice_no,
    invoice_status,
    amount_from,
    amount_to,
  } = purchaseInvoiceSearch;
  const searchVoucher = () => {
    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    searchReceiptVoucher(token, user_id, {
      from_date,
      to_date,
      invoice_type,
      supplier_name,
      invoice_no,
      invoice_status,
      amount_from,
      amount_to,
    });
  };

  const clearForm = () => {
    setPurchaseInvoiceSearch({
      from_date: "",
      to_date: "",
      supplier_name: "",
      invoice_no: "",
      invoice_type: "",
      invoice_status: "",
      amount_from: "",
      amount_to: "",
    });
  };

  useEffect(() => {
    if (token && user_id) {
      searchReceiptVoucher(token, user_id, { page: 1 });
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id,]);

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Purchase Invoice Search</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={purchaseInvoiceSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={purchaseInvoiceSearch.to_date}
            />
          </div>

          {/* supplier_name */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Supplier Name</label>
            <input
              type="text"
              name="supplier_name"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.supplier_name}
              onChange={onValueChange}
              placeholder="Supplier Name"
            />
          </div>

          {/* invoice_no */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Invoice Number</label>
            <input
              type="text"
              name="invoice_no"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.invoice_no}
              onChange={onValueChange}
              placeholder="Invoice Number"
            />
          </div>

          {/* invoice_type */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Invoice Type</label>
            <select
              name="invoice_type"
              className="form-select bg-light padding-pt-9"
              value={purchaseInvoiceSearch.invoice_type}
              onChange={onValueChange}
            >
              <option value="">Select Invoice Type</option>
              <option value="RCM">RCM</option>
              <option value="Regular">Regular</option>
            </select>
          </div>

          {/* invoice_status */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Invoice Status</label>
            <select
              name="invoice_status"
              className="form-select bg-light padding-pt-9"
              value={purchaseInvoiceSearch.invoice_status}
              onChange={onValueChange}
            >
              <option value="">Select Invoice Status</option>
              <option value="Paid">Paid</option>
              <option value="Posted">Posted</option>
              <option value="Draft">Draft</option>
            </select>
          </div>

          {/* amount_from */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Amount From</label>
            <input
              type="number"
              name="amount_from"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.amount_from}
              onChange={onValueChange}
              placeholder="0.00"
            />
          </div>

          {/* amount_to */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Amount To</label>
            <input
              type="number"
              name="amount_to"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.amount_to}
              onChange={onValueChange}
              placeholder="0.00"
            />
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => searchVoucher()}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-search me-1"></i> Search
            </button>

            <button
              onClick={() => clearForm()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>

            <button className="btn btn-light border px-4">
              <i class="fa-solid fa-file-export"></i> Export
            </button>

            <button className="btn btn-danger px-4">
              <i class="fa-solid fa-file"></i> New Invoice
            </button>
            <button className="btn btn-danger px-4">
              <i class="fa-solid fa-download"></i> Bulk Import
            </button>
          </div>
        </div>
      </div>

      {/* table */}
      <div className="card p-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="fw-semibold mb-3">Purchase Invoice</h5>
        </div>
        <div className="table-responsive custom-table query-list-table mt-4">
          <Table
            className="table datanew dataTable no-footer"
            // rowSelection={rowSelection}
            dataSource={dataSourcer}
            columns={columns}
            pagination={false}
            rowClassName={(record) =>
              record.is_priority === "YES" ? "prior-query" : ""
            }
          />
        </div>

        <AccountPagination
          currentPage={ReceiptVoucherCurrentPage}
          totalPages={ReceiptVoucherTotalPage}
          onPageChange={(page) => {
            searchReceiptVoucher(token, user_id, {
              page,
              from_date,
              to_date,
              invoice_type,
              supplier_name,
              invoice_no,
              invoice_status,
              amount_from,
              amount_to,
            });
          }}
        />
      </div>


      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewLoading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : viewData ? (
            <div className="container-fluid">

              {/* BASIC INFO */}
              <div className="row mb-3">
                <div className="col-md-3"><strong>Invoice ID:</strong> {viewData.invoice_id}</div>
                <div className="col-md-3"><strong>Invoice No:</strong> {viewData.invoice_no}</div>
                <div className="col-md-3">
                  <strong>Date:</strong>{" "}
                  {new Date(viewData.invoice_date).toLocaleDateString()}
                </div>
                <div className="col-md-3"><strong>Status:</strong> {viewData.invoice_status}</div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4"><strong>Supplier:</strong> {viewData.supplier_name}</div>
                <div className="col-md-4"><strong>Docket No:</strong> {viewData.docket_no}</div>
                <div className="col-md-4"><strong>Type:</strong> {viewData.invoice_type}</div>
              </div>

              <div className="row mb-3">
                <div className="col-md-3"><strong>Currency:</strong> {viewData.currency_master ? `${viewData.currency_master?.currency_name}` : ""}</div>
                <div className="col-md-3"><strong>Exchange Rate:</strong> {viewData.exchange_rate}</div>
                <div className="col-md-3"><strong>Payment Terms:</strong> {viewData.payment_terms}</div>
                <div className="col-md-3">
                  <strong>Due Date:</strong>{" "}
                  {new Date(viewData.due_date).toLocaleDateString()}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4"><strong>Reference No:</strong> {viewData.reference_no}</div>
                <div className="col-md-4"><strong>PO No:</strong> {viewData.po_no}</div>
              </div>

              <div className="mb-4">
                <strong>Narration:</strong>
                <div className="border p-2 rounded bg-light">
                  {viewData.invoice_narration || "-"}
                </div>
              </div>

              {/* LINE ITEMS */}
              <h6 className="fw-semibold mb-2">Line Items</h6>
              <div className="table-responsive mb-4">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Service</th>
                      <th>Description</th>
                      <th>HSN</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Amount</th>
                      <th>Weight</th>
                      <th>Unit</th>
                      <th>Shipment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewData.line_items?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.service_type}</td>
                        <td>{item.service_description}</td>
                        <td>{item.HSN_code}</td>
                        <td>{item.quantity}</td>
                        <td>{item.rate}</td>
                        <td>{item.amount}</td>
                        <td>{item.weight}</td>
                        <td>{item.weight_unit}</td>
                        <td>
                          {item.shipment_id?.join(", ") || "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* TAX DETAILS */}
              <h6 className="fw-semibold mb-2">Tax Details</h6>
              <div className="row mb-3">
                <div className="col-md-3"><strong>Taxable:</strong> ₹ {viewData.taxable_amount}</div>
                <div className="col-md-3"><strong>CGST ({viewData.cgst_rate}%):</strong> ₹ {viewData.cgst_amount}</div>
                <div className="col-md-3"><strong>SGST ({viewData.sgst_rate}%):</strong> ₹ {viewData.sgst_amount}</div>
                <div className="col-md-3"><strong>IGST ({viewData.igst_rate}%):</strong> ₹ {viewData.igst_amount}</div>
              </div>

              {/* SUMMARY */}
              <h6 className="fw-semibold mb-2">Summary</h6>
              <div className="row mb-2">
                <div className="col-md-3"><strong>Sub Total:</strong> ₹ {viewData.sub_total}</div>
                <div className="col-md-3"><strong>Surcharge:</strong> ₹ {viewData.total_surcharges}</div>
                <div className="col-md-3"><strong>Total Tax:</strong> ₹ {viewData.total_tax}</div>
                <div className="col-md-3"><strong>Rounding:</strong> ₹ {viewData.rounding_adjustment}</div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4"><strong>Grand Total:</strong> ₹ {viewData.grand_total}</div>
                <div className="col-md-4">
                  <strong>TDS ({viewData.tds_rate}%):</strong> ₹ {viewData.tds_amount}
                </div>
                <div className="col-md-4 text-success fw-bold">
                  <strong>Net Payable:</strong> ₹ {viewData.net_payable}
                </div>
              </div>

            </div>
          ) : (
            <div>No Data Found</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Edit modal  */}
      <EditPurchaseInvoiceModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        editData={editData}
        refresh={() =>
          searchReceiptVoucher(token, user_id, { page: 1 })
        }
      />
    </>
  );
};

export default TradeInvoicesPurchaseInvoiceSearch;
